module.exports = __webpack_public_path__ + "4b08f00bf1bc6a7111515bc9ce93d40b.png";